import ALERT_TYPES from "./alert/users.alert.types"

class Users {
    [x: string]: any;
 	 static $inject = ['$stateParams','UsersDetails','PermPermissionStore','ModalService','UsersAlertService', 'NotificationService', 'Router'];
    constructor($stateParams, UsersDetails, PermPermissionStore, ModalService, UsersAlertService, NotificationService, Router) {
        this.params = $stateParams;
        this.getFullName = UsersDetails.getFullName;
        this.isActive = UsersDetails.isActive;
        this.PermPermissionStore = PermPermissionStore;
        this.ModalService = ModalService;
        this.userNameTruncate = 25;
        this.UsersAlertService = UsersAlertService;
        this.notificationService = NotificationService;
        this.router = Router;
    }

    $onInit() {
        this.currentUser = this.getUsersForCurrentState()[0];
    }

    // destroys closable notification of 'failed StripePayment' which also redirects here
    $onDestroy() {
      this.notificationService.dismiss();
    }

    toState(user) {
        this.UsersAlertService.deleteSuccessAlerts();
        if(user.state === 'PENDING') {
          this.router.navigateByUrl(`/users/${this.state}/${user.uniqueId}/invite`)
        } else {
          this.router.navigateByUrl(`/users/${this.state}/${user.uniqueId}/details`);
        }
    }

    getState() {
        return this.state === 'all' || !this.state ? undefined : this.state.toUpperCase();
    }

    isPending(user) {
        return user.state === 'PENDING';
    }

    setCurrentUser(user) {
        this.currentUser = user ? user : this.getUsersForCurrentState()[0];
    }

    responsiveMenuShow() {
        this.showMenu = !this.showMenu
    }

    onChangeFind(find) {
        this.find = find;
    }

    isSetUserView() {
        return this.userIndex;
    }

    isPendingAndActive(user) {
        return !this.isPending(user) && !this.isActive(user)
    }

    listContainsUsers() {
        return this.getUsersForCurrentState().length > 0;
    }

  listContainsMoreThanOneUser() {
    return this.getUsersForCurrentState().length > 1;
  }

    getUsersForCurrentState() {
        return this.userList.filter((user) => user.state === (this.getState() ? this.getState() : user.state));
    }

    gotoAllUsers() {
      this.router.navigateByUrl(`/users/all/0/details`);
    }

    showLimitUsersAlert(){
        this.UsersAlertService.prependAlert(ALERT_TYPES.noFreeSlots);
    }

    getUsersList() {
      return this.userList;
    }

    get validForm() {
      return this.invitation.email && this.invitation.roleId;
    }

    get changedPlan(){
      return this.params.changedPlan;
    }

    get newInvitation(){
      return this.params.newInvitation;
    }

    isCurrentUser(currentUserIndex) {
        return currentUserIndex === parseInt(this.userIndex, 10);
    }

}

export default {
    controller: Users,
    template : require('./users.html'),
    bindings: {userList: '<', userStats: '<', state: '<', userIndex: '<'}
}
